export enum SESSION_STATE {
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  UPCOMING = "UPCOMING",
}

export enum PACKAGE_POPUP_TYPE {
  NONE = "",
  CREATE_PACKAGE = "create-package",
  EDIT_PACKAGE = "edit-package",
  START_TREATMENT = "start-treatment",
  CURRENT_TREATMENT = "current-treatment",
  START_OR_CURRENT_TREATMENT = "start-or-current-treatment",
}

export enum PACKAGE_PRICING_MODEL {
  ONE_TIME = "ONE_TIME",
  PER_VISIT = "PER_VISIT",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export enum PACKAGE_STATUS {
  DRAFT = "DFT",
  ACTIVE = "ACT",
  COMPLETED = "CMP",
  EXPIRED = "EXP",
  ONGOING = "ONG",
}

export enum PACKAGE_TYPE {
  TREATMENT_PLAN = "TREATMENT_PLAN",
  SUBSCRIPTION_PLAN = "SUBSCRIPTION_PLAN",
}
